import { render } from "./ChangeForgettedPasswordForm.vue?vue&type=template&id=076a8ddd"
import script from "./ChangeForgettedPasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangeForgettedPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/LoginFlow/ChangeForgettedPasswordForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "076a8ddd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('076a8ddd', __exports__)) {
    api.reload('076a8ddd', __exports__)
  }
  
  module.hot.accept("./ChangeForgettedPasswordForm.vue?vue&type=template&id=076a8ddd", () => {
    api.rerender('076a8ddd', render)
  })

}


export default __exports__